import { render, staticRenderFns } from "./ApplyBenefitsList.vue?vue&type=template&id=01b05475&"
import script from "./ApplyBenefitsList.vue?vue&type=script&lang=js&"
export * from "./ApplyBenefitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports